import { render, staticRenderFns } from "./website-banner.vue?vue&type=template&id=4de7a9ae&scoped=true&"
import script from "./website-banner.vue?vue&type=script&lang=js&"
export * from "./website-banner.vue?vue&type=script&lang=js&"
import style0 from "./website-banner.vue?vue&type=style&index=0&id=4de7a9ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de7a9ae",
  null
  
)

export default component.exports